import axios from 'axios';
import { api } from '../Users/user';

const API = axios.create({
  baseURL: api + '/api/server', // Ajusta si es necesario
});

export default API;
